import { useState } from "react";
import { Popover } from "react-tiny-popover";

const Switch = ({ onClick, isActived, disable = false, tooltip = false, contentTooltip }) => {
   const [isOpen, setIsOpen] = useState(false);
   const handleOpenTooltip = () => {
      if (tooltip) {
         setIsOpen(true)
      }
   }

   return (
      <Popover
         isOpen={isOpen}
         align={'center'}
         positions={['bottom']}
         clickOutsideCapture={true}
         content={contentTooltip}
      >
         <span
            onMouseLeave={() => setIsOpen(false)}
            onMouseEnter={handleOpenTooltip}>
            <button type="button" className={`app-switch app-switch-small ${isActived ? 'app-switch-checked' : 'app-switch'} ${disable && 'app-switch-disabled'}`} onClick={onClick}>
               <span className="app-switch-inner">
               </span>
               <div className="app-click-animating-node">
               </div>
            </button>
         </span>
      </Popover>
   )
}

export default Switch;